import config from '@/config/config';
import {ApiEndpointEnum} from '@/enums/ApiEndpointEnum';


export const getRequest = (endpoint: string, params?: URLSearchParams): Request => {
  return new Request( endpoint + (params ? '?' + params?.toString() : ''), {
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
  });
};

export const postRequest = (endpoint: string, body: BodyInit | null | undefined): Request => {
  return new Request( endpoint, {
    method: 'POST',
    body: body,
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
  });
};

export const getApiEndpointErrorMessage = (endpoint: ApiEndpointEnum) => {
  switch (endpoint) {
    case ApiEndpointEnum.GetCart:
      return 'Get cart';
    case ApiEndpointEnum.UpdateCart:
      return 'Update cart';
    case ApiEndpointEnum.RemoveLineItem:
      return 'Remove cart item';
    case ApiEndpointEnum.CommerceCountries:
      return 'Get shipping countries';
    case ApiEndpointEnum.CommerceAddressBase:
      return 'Get address';
    case ApiEndpointEnum.UserGeo:
      return 'Get user geo';
    default:
      return '';
  }
};
